import lang from '../assets/lang/v1';

class langRegister {

    static file = lang;
    static language = "en";

    static getItem(view, item, lang){
        try {
            if(!lang){
                lang = langRegister.language;
            }
            if(langRegister.file[view][item][lang]){
                return langRegister.file[view][item][lang];
            }else{
                return "-";
            }
        }catch (error) {
            return "-";
        }
    }

    //SHORTENER
    static get(view, item, lang){
        return langRegister.getItem(view, item, lang);
    }

}

export {langRegister}


// WEBPACK FOOTER //
// ./src/services/langRegister.js